import { LocationRegionSchema } from '@packages/contracts';

export const categories = [
	{
		id: LocationRegionSchema.enum.CENTRAL,

		label: LocationRegionSchema.enum.CENTRAL.replace('_', ' ').toLocaleLowerCase(),
		value: LocationRegionSchema.enum.CENTRAL,
	},
	{
		id: LocationRegionSchema.enum.NORTH,

		label: LocationRegionSchema.enum.NORTH.replace('_', ' ').toLocaleLowerCase(),
		value: LocationRegionSchema.enum.NORTH,
	},
	{
		id: LocationRegionSchema.enum.SOUTH,

		label: LocationRegionSchema.enum.SOUTH.replace('_', ' ').toLocaleLowerCase(),
		value: LocationRegionSchema.enum.SOUTH,
	},
	{
		id: LocationRegionSchema.enum.EAST,

		label: LocationRegionSchema.enum.EAST.replace('_', ' ').toLocaleLowerCase(),
		value: LocationRegionSchema.enum.EAST,
	},
	{
		id: LocationRegionSchema.enum.WEST,

		label: LocationRegionSchema.enum.WEST.replace('_', ' ').toLocaleLowerCase(),
		value: LocationRegionSchema.enum.WEST,
	},
	{
		id: LocationRegionSchema.enum.NORTH_EAST,

		label: LocationRegionSchema.enum.NORTH_EAST.replace('_', ' ').toLocaleLowerCase(),
		value: LocationRegionSchema.enum.NORTH_EAST,
	},
];
